"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionPointCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const helpers_1 = require("../../helpers");
const react_1 = require("react");
const formik_1 = require("formik");
const PositionCardTemplate_1 = require("./PositionCardTemplate");
const react_ui_1 = require("@pasport/react-ui");
const validateValueX = (x) => {
    return 900000 < x && x < 1250000;
};
const validateValueY = (y) => {
    return 380000 < y && y < 950000;
};
const Form = (0, helpers_1.createForm)();
const isPositionValid = (pos) => {
    return pos && validateValueX(pos.x) && validateValueY(pos.y);
};
const PositionPointCard = ({ mode, version, title }) => {
    const [fieldX, , helpersX] = (0, formik_1.useField)({
        name: `pozice.x`,
        validate: (value) => {
            return position && !validateValueX(value) ? "Nesprávný formát" : undefined;
        },
    });
    const [fieldY, , helpersY] = (0, formik_1.useField)({
        name: "pozice.y",
        validate: (value) => {
            return position && !validateValueY(value) ? "Nesprávný formát" : undefined;
        },
    });
    const [isFilled, setIsFilled] = (0, react_1.useState)(Boolean(fieldX.value) && Boolean(fieldY.value));
    const readablePosition = fieldX.value && fieldY.value ? {
        x: fieldX.value,
        y: fieldY.value
    } : undefined;
    const position = readablePosition && isPositionValid(readablePosition) ? (0, helpers_1.mapPositionToRealJTSK)(readablePosition.x, readablePosition.y) : undefined;
    const handlePositionSelection = (position) => {
        console.log("position set to", position);
        setIsFilled(Boolean(position));
        const readablePosition = position ? (0, helpers_1.mapPositionToReadableJTSK)(position.x, position.y) : undefined;
        helpersX.setValue(readablePosition?.x || "");
        helpersY.setValue(readablePosition?.y || "");
    };
    return ((0, jsx_runtime_1.jsx)(PositionCardTemplate_1.PositionCardTemplate, { mode: mode, version: version, title: title, isEmptyState: !isFilled, position: {
            objectType: 'point',
            position
        }, onPositionSelection: (pos) => {
            handlePositionSelection(pos.position);
        }, footerSlot: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_ui_1.DetailItemRow, { align: "top", children: [(0, jsx_runtime_1.jsx)(Form.NumberItem, { name: ['pozice', 'y'], label: "Pozice Y", mode: mode, floatNumber: true }), (0, jsx_runtime_1.jsx)(Form.NumberItem, { name: ['pozice', 'x'], label: "Pozice X", mode: mode, floatNumber: true })] }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-between align-items-center ", children: (0, jsx_runtime_1.jsx)("div", { className: "small text-muted", children: "Prostorov\u00E1 informace je v sou\u0159adnic\u00EDch S-JTSK." }) })] })) }));
};
exports.PositionPointCard = PositionPointCard;
